<script lang="javascript">
    import Spinner from "./Spinner.svelte";
    import {Card, Button, Row, Col, Container, Tabs, Tab} from 'svelte-chota';
    import {mdiLogin} from '@mdi/js';
    import Services from "./Services.svelte";

    export let keycloak;
    export let profile = undefined;
    let active_tab = "services";

    let auth = keycloak.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    }).then((authenticated) => {
        if (authenticated) {
            keycloak.loadUserProfile().then((p) => {
                profile = p;
            })
        }
        return authenticated;
    });

    function login() {
        keycloak.login();
    }


</script>

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>

<main class="stretch">
    {#await auth}
        <div class="is-full-screen is-center overlay">
            <Spinner scale="3"/>
        </div>
    {:then authenticated}
        {#if authenticated}
            <Tabs full bind:active={active_tab} style="margin-bottom: calc(var(--grid-gutter)/2);">
                <Tab tabid="services" class="text-light">Services</Tab>
            </Tabs>

            {#if active_tab === "services"}
                {#if profile}
                    <Services keycloak={keycloak} profile={profile}/>
                {:else}
                    <div class="is-full-screen is-center overlay">
                        <Spinner scale="3"/>
                    </div>
                {/if}
            {/if}
        {:else}
            <Row style="margin-top: 64px">
                <Col class="is-horizontal-align"><h3>You are not logged in</h3></Col>
            </Row>
            <Row>
                <Col class="is-horizontal-align">
                    <Button primary icon={mdiLogin} on:click={login}>Login with kkInc account</Button>
                </Col>
            </Row>
        {/if}
    {:catch error}
        <p>Error ocurred during auth phase, please try again</p>
    {/await}
</main>
